import { createActions, handleActions } from 'redux-actions'

export const { startLoading, endLoading } = createActions({
  START_LOADING: null,
  END_LOADING: null,
})

const DEFAULT_LOADING = {
  loadingCounter: 0,
}

export default handleActions(
  {
    [startLoading.toString()]: (state) => ({
      ...state,
      loadingCounter: state.loadingCounter + 1,
    }),
    [endLoading.toString()]: (state) => {
      const newCounter = state.loadingCounter - 1
      return {
        ...state,
        loadingCounter: newCounter < 0 ? 0 : newCounter,
      }
    },
  },
  DEFAULT_LOADING
)
